module.exports = __webpack_public_path__ + "media/images/emblems/Eisten_Wappen-6fa5fbd613ae2cc794369b758a889313.png";